/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Server_Summary_TitleInputs */

const en_us2_push_server_summary_title = /** @type {(inputs: Push_Server_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session complete`)
};

const pt_br2_push_server_summary_title = /** @type {(inputs: Push_Server_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino concluído`)
};

const es_419_push_server_summary_title = /** @type {(inputs: Push_Server_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento completado`)
};

const pt_pt2_push_server_summary_title = /** @type {(inputs: Push_Server_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino concluído`)
};

const fr_fr2_push_server_summary_title = /** @type {(inputs: Push_Server_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance terminée`)
};

const de_de2_push_server_summary_title = /** @type {(inputs: Push_Server_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheit abgeschlossen`)
};

const it_it2_push_server_summary_title = /** @type {(inputs: Push_Server_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento completato`)
};

/**
* | output |
* | --- |
* | "Session complete" |
*
* @param {Push_Server_Summary_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_server_summary_title = /** @type {((inputs?: Push_Server_Summary_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Server_Summary_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_server_summary_title(inputs)
	if (locale === "es-419") return es_419_push_server_summary_title(inputs)
	if (locale === "pt-PT") return pt_pt2_push_server_summary_title(inputs)
	if (locale === "fr-FR") return fr_fr2_push_server_summary_title(inputs)
	if (locale === "de-DE") return de_de2_push_server_summary_title(inputs)
	if (locale === "it-IT") return it_it2_push_server_summary_title(inputs)
	return en_us2_push_server_summary_title(inputs)
});
export { push_server_summary_title as "push-server.summary_title" }